<template>
  <div class="icon chevron">
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 40 40">
      <path stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="3.3333333333333"
      d="M11.515 17L20 25.485 28.485 17"/>
    </svg>
  </div>
</template>

<script setup>
</script>
